/** Build the culling viewport from a 2D google.maps.Map (bounds + zoom). */

import { CLIENT_CONFIG } from '@/config';
import type { ViewportState } from '@/stores/map-viewport-store';
import { expandBox, boxCenter } from './viewport-box';

/** Read the 2D map's visible bounds + zoom into a normalized {@link ViewportState}. */
export function viewportFrom2D(map: google.maps.Map): ViewportState | null {
  const bounds = map.getBounds();
  const zoom = map.getZoom();
  if (!bounds || typeof zoom !== 'number') return null;

  const ne = bounds.getNorthEast();
  const sw = bounds.getSouthWest();
  const box = expandBox({ north: ne.lat(), south: sw.lat(), east: ne.lng(), west: sw.lng() });
  return { box, center: boxCenter(box), active: zoom >= CLIENT_CONFIG.viewportMinZoom2D };
}
